import React from 'react'
import { CCard, CCardBody, CCol, CRow } from '@coreui/react-pro'
import { TStrategyPerformance } from '../../list/types'
import { formatNumber } from 'chart.js/helpers'
import { getNumberFormat } from '../../../../../libs/utils'

type Props = {
  data: TStrategyPerformance
  aiMagic: number
}
export const StrategyPerformance: React.FC<Props> = ({ data, aiMagic }) => {
  if (!data) {
    return (
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={8}>
              <div className="mt-2">No data</div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    )
  }
  const { gain, winRate, risk, activeDays, sumProfit, sumLoss } = data

  return (
    <CCard className="mb-4">
      <CCardBody>
        <CRow>
          <CCol sm={8}>
            <div className="mt-2">
              <span className="text-muted">Gain:</span> {gain}
            </div>
            <div className="mt-2">
              <span className="text-muted">Win rate:</span>{' '}
              {getNumberFormat((+winRate * 100) | 0, 0)} %
            </div>
            <div className="mt-2">
              <span className="text-muted">Risk:</span> {risk}
            </div>
            <div className="mt-2">
              <span className="text-muted">Active days:</span> {activeDays}
            </div>
            <div className="mt-2">
              <span className="text-muted">Profit:</span> {sumProfit}
            </div>
            <div className="mt-2">
              <span className="text-muted">Loss:</span> {sumLoss}
            </div>
            <div className="mt-2">
              <span className="text-muted">AI Magic:</span> {aiMagic}
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  )
}
